import type { TarotCardItem } from '@/types';
import { CardItem } from '@/components/result/CardItem';
import styles from './CardList.module.css';

interface CardListProps {
  cards: TarotCardItem[];
  heading: string;
  headingIcon?: string;
}

export function CardList({ cards, heading, headingIcon }: CardListProps) {
  return (
    <section className={styles.block}>
      <div className={styles.head}>
        {headingIcon ? (
          <span className={styles.headIco} aria-hidden>
            {headingIcon}
          </span>
        ) : null}
        <span>{heading}</span>
      </div>
      <div className={styles.list}>
        {cards.map((c, idx) => (
          <div key={`${c.name}-${idx}`}>
            {idx > 0 ? <div className={styles.div} /> : null}
            <CardItem {...c} />
          </div>
        ))}
      </div>
    </section>
  );
}
